/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import axios from 'axios';
import {fetchCollectionSuccess,createNewPart, getBookBuildStatus} from '../_actions/collection.actions';
import {fetchPCSLogsSuccess} from '../_actions/pcs.logs.actions';
import api from './api.services';
import {fetchApiDataFailure} from '../_actions/common.actions';
import {enableAceessCodeSendToPCS} from '../_actions/access.code.pcs.actions';
import {setCompCode} from '../_actions/comp.code.actions';
import {fetchContactDetailsSuccess} from "../_actions/order.details.actions";
import {showMessage} from "../_actions/message.actions";
import {fetchPdfsByCollectionId} from "../_thunks/pdf.links.thunk";
import {getSchoolDetails} from "../_thunks/order.details.thunk";
import {fetchEtextStatusSuccess, fetchEtextOptimizeStatusSuccess, fetchProductDetailsSuccess, fetchOfferDetailsSuccess} from '../_actions/etext.publish.actions';
import {fetchVitalsourceBookStatusSuccess,fetchVitalsourceStatusSuccess} from '../_actions/vitalsource.publish.action';
import {setResourcePDFURL, setPDFURLLoader, resetPDFURLLoader} from "../_actions/search.actions";
/**
 *
 * @param collectionId
 * @param chapterId
 * @param payload = {
            insertAfter: this.props.searchInitializationData.insertAfter,
            resourceIds: [],
            currency: activeCollection.geo.code,
            priceType: activeCollection.collectionType
        }
 * @returns {Function}
 */
export const addToCollection = (collectionId,chapterId,payload) => dispatch => {
    axios.post(api.add_to_collection.replace('{collection-id}', collectionId).replace('{chapterId}', chapterId), payload)
        .then(response => {
            console.log("responseData:",response.data);
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const getCollectionById = (collectionId) => dispatch => {
    axios.get(api.get_collection_by_id.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchCollectionSuccess(response.data));
            const accessCodeSendToPCS = response.data.accessCodeIsbn ? true : false;
            dispatch(enableAceessCodeSendToPCS(accessCodeSendToPCS));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const assignAccessCodeISBN = (collectionId) => dispatch => {
    axios.post(api.assign_access_code_isbn.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchCollectionSuccess(response.data));
            const accessCodeSendToPCS = response.data.accessCodeIsbn ? true : false;
            dispatch(enableAceessCodeSendToPCS(accessCodeSendToPCS));
            dispatch(showMessage({messageKey: 'access_code_isbn_generate_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'access_code_isbn_generate_failed', type: 'error' }));
        });
};

export const assignCompCodeVS = (collectionId) => dispatch => {
    axios.post(api.assign_comp_code_vs.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(getCompCodeVS(collectionId, 'PROJECT_SPECIALIST'));
            dispatch(showMessage({messageKey: 'comp_code_isbn_generate_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'comp_code_isbn_generate_failed', type: 'error' }));
        });
};

export const getCompCodeVS = (collectionId,redeemType) => dispatch => {
    axios.get(api.get_comp_code.replace('{collection-id}', collectionId).replace('{redeemType}', 'PROJECT_SPECIALIST'))
        .then(response => { 
            dispatch(setCompCode(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            
        });
};


export const sendToPCS = (collectionId, issAccessCode) => dispatch => {
    const messageKeySuccess = issAccessCode ? 'access_code_send_pcs_success' : 'send_to_pcs_success';
    const messageKeyFailed = issAccessCode ? 'access_code_send_pcs_failed' : 'send_to_pcs_failed';
    dispatch(enableAceessCodeSendToPCS(false));
    axios.post(api.send_to_PCS.replace('{collection-id}', collectionId).replace('{access-code}', issAccessCode))
        .then(response => {
            dispatch(fetchPCSLogsSuccess(response.data));
            dispatch(enableAceessCodeSendToPCS(true));
            response.status && response.status === 200 ? dispatch(showMessage({messageKey: messageKeySuccess, type: 'success' })) : dispatch(showMessage({messageKey: messageKeyFailed, type: 'error' }));

        })
        .catch(error => {
            dispatch(enableAceessCodeSendToPCS(true));
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: messageKeyFailed, type: 'error' }));
        });
};

export const getPCSLogs = (collectionId) => dispatch => {
    axios.get(api.get_pcs_logs.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchPCSLogsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};


export const saveCourseInfo = (collectionId) => (dispatch, getState) => {
    axios.patch(api.save_course_information.replace('{collection-id}', collectionId), getState().activeCollection.collectionCourseInformation)
        .then(response => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};


export const reorderCollections = (collectionId, chapters) => dispatch => {
    axios.put(api.update_collection_chapter_resources.replace('{collection-id}', collectionId), chapters)
        .then(() => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const reorderCollectionChapters = (collectionId, chapterId, sequence) => dispatch => {
    axios.put(api.update_collection_chapters.replace('{collection-id}', collectionId).replace('{chapter-id}',chapterId).replace('{sequence}',sequence))
        .then(() => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const saveInstructorCourseContact = (collectionId, params) => ( dispatch, getState ) => {
    const options = {
        instructor: !params ? null : {...params},
        institution: null
    };

    axios.patch(api.save_course_contacts.replace('{collection-id}', collectionId), options)
        .then(response => {
            dispatch(showMessage({messageKey: 'course_contact_save_success', type: 'success' }));
            dispatch(fetchContactDetailsSuccess(response.data));
            dispatch(resetCourseAssocation (collectionId,'INVITE_EMAIL','RESEND',options));
            dispatch(resetCourseAssocation (collectionId,'COURSE_ASSOCIATION','RESEND',options));
            // Fetching School details to reset Institute selection
            setTimeout(()=> {dispatch(getSchoolDetails(collectionId));},2000);
        })
        .catch(error => {
            dispatch(showMessage({messageKey: 'course_contact_save_failed', type: 'error' }));
        });
};
export const resetCourseAssocation = (collectionId, taskType, Status, params) => ( dispatch, getState ) => {
    const options = {
        instructor: !params ? null : {...params},
        institution: null
    };
    if(getState().etextStatuses.COURSE_CREATION.includes("SUCCESS")){
        axios.post(api.reset_course_association.replace('{collection-id}', collectionId)
            .replace('{taskType}', taskType)
            .replace('{status}', Status), options)
            .then(response => {
            })
            .catch(error => {
                console.log('Error ',error);
            });
    }

};

export const getDRVS = (collectionId) => dispatch => {
    return axios.get(api.get_drvs.replace('{collection-id}', collectionId));
};

export const getOMS = (resourceIds) => dispatch => {
    return axios.post(api.get_oms, resourceIds);
};

export const deleteResources = (collectionId, resourceList) => dispatch => {
    axios.put(api.delete_resources.replace('{collection-id}', collectionId), resourceList)
        .then(() => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'resource_delete_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'resource_delete_failed', type: 'error' }));
        });
};

export const deletePart = (collectionId, chapterId, removeResources) => dispatch => {
    axios.delete(api.delete_part.replace('{collection-id}', collectionId)
        .replace('{chapter-id}', chapterId)
        .replace('{removeResources}', removeResources))
        .then(response => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'part_delete_success', type: 'success' }));
            //TODO Future implementations
            /*if (removeResources) {
                dispatch(initCollection(collectionId));
                dispatch(validateMixingRules(collectionId));
            } else {
                dispatch(buildTOC(collectionId));
            }*/
        })
        .catch((error) => {
            dispatch(fetchApiDataFailure({errorType: 'error_delete_part', error: error}));
            dispatch(showMessage({messageKey: 'part_delete_failed', type: 'error' }));
        });
};

export const updateChapterTitle = (collectionId, chapterId, title) => dispatch => {
    axios.patch(api.update_chapter_title.replace('{collection-id}', collectionId)
        .replace('{chapter-id}', chapterId),title)
        .then(response => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        }).catch(error=>{
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const rebuildBook = (collectionId) => dispatch => {
    axios.post(api.book_rebuild.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchPdfsByCollectionId(collectionId));
            dispatch(showMessage({messageKey: 'book_rebuild_started', type: 'success'}));
        })
        .catch(error => {
            dispatch(showMessage({messageKey:'book_already_send_to_build' , type: 'error'}));
        });

};

export const sendToEtext = (collectionId, deliveryType) => dispatch => {
    var headers = { 'Delivery-Type': deliveryType}; //Add new header 'Delivery-Type': etext to Content Publish Service API requests : BLUESCP-13960
    axios.post(api.send_etext.replace('{collection-id}', collectionId),{ headers: headers })
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'fail_message', type: 'error' }));
        });

};
export const sendToVitalsource = (collectionId, deliveryType) => dispatch => {
    var headers = { 'Delivery-Type': deliveryType}; 
    axios.post(api.send_vitasource.replace('{collection-id}', collectionId),{ headers: headers })
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'fail_message', type: 'error' }));
        });

};

export const getEtextPublishStatuses = (collectionId) => dispatch => {
    axios.get(api.etext_publish_status.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchEtextStatusSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};
export const getVitalsourcePublishStatuses = (collectionId) => dispatch => {
    axios.get(api.vitalsource_publish_status.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchVitalsourceStatusSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const getEtextOptimizeStatuses = (collectionId) => dispatch => {
    axios.get(api.etext_optimize_status.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchEtextOptimizeStatusSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const getProductDetails = (collectionId) => dispatch => {
    axios.get(api.get_product_details.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchProductDetailsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const getOfferDetails = (collectionId) => dispatch => {
    axios.get(api.get_offer_details.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchOfferDetailsSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const updateProductDetails = (collectionId) => (dispatch, getState) => {
    axios.put(api.update_product_details.replace('{collection-id}', collectionId), {isCopyable :getState().productDetails.courses.isCopyable, productStage :getState().productDetails.productStage})
        .then(response => { 
            dispatch(getProductDetails(collectionId));
            dispatch(fetchProductDetailsSuccess(response.data));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        }).catch(error => {
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const updateOfferDetails = (collectionId) => (dispatch, getState) => {
    let offerUpdateDetails = getState().offerDetails.offerChangeDetails;
    Object.keys(offerUpdateDetails).forEach(offerId => {
        axios.put(api.update_offer.replace('{collection-id}', collectionId).replace('{offerId}', offerId), { offerEndDate: offerUpdateDetails[offerId].offerEndDate })
            .then(response => {
                dispatch(showMessage({ messageKey: 'default_success', type: 'success' }));
            })
            .catch(error => {
                dispatch(fetchApiDataFailure(error));
                dispatch(showMessage({ messageKey: 'default_failed', type: 'error' }));
            });
    });
};

export const getVitalsourceBookStatuses = (collectionId) => dispatch => {
    axios.get(api.vitalsource_book_status.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchVitalsourceBookStatusSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};
export const sendInviteEmail = (collectionId) => dispatch => {
    axios.post(api.send_invite_email.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'fail_message', type: 'error' }));
        });

};

export const sendVitalsourceInviteEmail = (collectionId) => dispatch => {
    axios.post(api.send_vitalsource_invite_email.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'fail_message', type: 'error' }));
        });

};
export const createAccessCardOffer = (collectionId) => dispatch => {
    axios.post(api.create_offer.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'fail_message', type: 'error' }));
        });

};

export const createNewChapter = (collectionId, payload) => dispatch => {
    axios.post(api.create_part.replace('{collection-id}', collectionId),payload)
        .then(response => {
            dispatch(getCollectionById(collectionId));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const getBookBuildDetails = (collectionId) => dispatch => {
    axios.get(api.get_book_build_status.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(getBookBuildStatus(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const fetchPDFURL = (resourceId) => dispatch => {
    dispatch(setPDFURLLoader(resourceId));
    axios.get(api.get_resource_pdf_url.replace('{resource-id}', resourceId))
        .then(response => {
            dispatch(setResourcePDFURL(response.data.url));
            dispatch(resetPDFURLLoader());
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};


export const getStudentInviteLink = (collectionId) => {
    return axios.get(api.get_student_invite_link.replace('{collection-id}', collectionId));
    /*return get(api.get_student_invite_link.replace('{collection-id}', collectionId))
        .then(response => dispatch(getStudentInviteLinkSuccess(response)))
        .catch(e => dispatch(getStudentInviteLinkFailure(e)));*/
};


// WEBPACK FOOTER //
// ./src/_thunks/collection.thunk.js